module.exports = __webpack_public_path__ + "static/transparency-quotes-9030eaad7bcec210f4bd48517ba8dc62.mp4";